<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3">
        <Card body-classes="p-3" card-classes="shadow-sm">
          <template #header>
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h5 class="mb-0 text-danger">
                <vue-feather type="alert-triangle" class="me-2"></vue-feather>
                Low Stock Products - {{ store.name }}
              </h5>
              <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-center">
                  <label for="threshold" class="me-2 text-muted">Threshold:</label>
                  <input type="number" id="threshold" class="form-control form-control-sm" v-model="threshold" min="1" max="100">
                </div>
                <button class="btn btn-primary btn-sm" @click="getReport">
                  Refresh
                </button>
              </div>
            </div>
          </template>
          <div>
            <div v-if="loading" class="text-center py-5">
              <Spinner spinner-class="mb-1" />
              <p class="text-muted mt-2">Loading low stock products...</p>
            </div>
            <div v-else-if="reportData.length > 0">
              <div class="alert alert-warning">
                <vue-feather type="alert-circle" size="18" class="me-2"></vue-feather>
                <strong>{{ reportData.length }}</strong> product(s) are running low on stock (≤ {{ threshold }} units)
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Category</th>
                      <th>Current Stock</th>
                      <th>Sell Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in reportData" :key="item.id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.sku || 'N/A' }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.category_name || 'N/A' }}</td>
                      <td>
                        <span :class="item.current_stock === 0 ? 'badge bg-danger' : 'badge bg-warning'">
                          {{ item.current_stock + ' pcs' }}
                        </span>
                      </td>
                      <td>{{ formatNumber(item.sell_price) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="alert alert-success">
              <vue-feather type="check-circle" size="18" class="me-2"></vue-feather>
              All products are well stocked!
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import {decrypt} from "@/utils/crypto";
import analyticsService from "@/api/analyticsService";
import formatNumber from "@/utils/formatNumber";

export default {
  name: "LowStockProducts",

  data(){
    return {
      profile: {},
      store: {},
      loading: false,
      threshold: 10,
      reportData: []
    }
  },

  methods: {
    formatNumber,
    async getReport() {
      this.loading = true;
      try {
        const params = {
          store_id: this.store.id,
          threshold: this.threshold
        };

        const response = await analyticsService.getLowStockProducts(params);
        this.reportData = response || [];
      } catch(e) {
        console.error(e);
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')));
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')));
    await this.getReport();
  }
}
</script>

<style scoped>
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
